(function(){
	'use strict';
	angular.module('app.news')
	.controller('newsCtrl',['$scope','$filter', function($scope, $filter){

		var dummyCopy = "<p>SAN RAMON, CALIF. – Meridian, a full-service office property developer in California, is pleased to announce the purchase of 1000 Marina, a six-story 105,000-square-foot office building in San Mateo County, Calif. The seller was TA Associates, a private equity firm based in Boston, Massachusetts. Meridian paid just under $29 million for the 90%-leased building located in the Sierra Point Submarket in the city of Brisbane. The purchase closed in the final week of 2016 and represented Meridian’s second major office transaction in northern California since September when the firm sold The Atrium, a 77,000-square-foot office building in Pleasanton.</p><p>According to Dan Rosenbaum, Meridian’s Senior Vice President of Acquisitions in northern California, “This acquisition represents our largest general office acquisition to date. The building is located in northern San Mateo County in a very vibrant sub-market. South San Francisco and Brisbane are the epicenter of the biotech universe and we think that 1000 Marina will continue to benefit from that.”</p><p>Rosenbaum added, “Google, through its YouTube subsidiary, has purchased a tremendous amount of multi-tenant office space in San Bruno over the last year. As YouTube grows into those owned buildings, those displaced tenants will need to move somewhere. This was one of the drivers in our decision to buy this building. As is the case in most buildings that we buy, we will perform some significant upgrades to the building, including common areas and exterior gathering places. This purchase is consistent with our value-add approach towards general and medical office. We perceived that the in-place rents were below market and there were some aesthetic and livability upgrades to perform. While the building is not located within walking distance of public transportation, 1000 Marina has the Sierra Point Commuter Shuttle, which connects office workers to both BART and Cal-Train often and effectively.”</p><p>John Moutsanas, Vice President of Acquisitions at Meridian added, “Working with CBRE investment brokers Joe Moriarty and Seth McKinnon was great. They created a process in which the purchase negotiations, due-diligence and closing went very smoothly. The existing CBRE listing team of Simon Clark and Matt Mulry has been doing a great job bringing the asset’s rents to market and will continue on as our listing agents.”</p><p><a target='_blank' href='http://news.theregistrysf.com/meridian-buys-105000-sf-office-building-san-mateo-county-29mm/'>http://news.theregistrysf.com/meridian-buys-105000-sf-office-building-san-mateo-county-29mm/</a></p><p><strong>About Meridian</strong><br />A division of Marcus & Millichap Company, San Ramon, Calif. based Meridian Property Company is a full-service real estate developer having completed over one million square feet of innovative and integrated commercial office, primarily medical, since its inception in 2000. Meridian\'s services are broad in scope but meticulous in detail — from site evaluation and land acquisition to entitlement and planning to construction and management. For more information, see <a target='_blank' href='mpcca.com'>mpcca.com</a>.</p>";

		$scope.parseNews = function(elem){
			console.dir(elem);
		}

		$scope.newsSource = [
			{
				year: 2017,
				articles: [
					{				
						date: "January 3",
						source: "theregistry.com",
						author: 'Publisher',
						title: "Meridian Buys 105,000 SF Office Building in San Mateo County for $29M",
						blurb: "Testing Meridian, a full-service office property developer in California, is pleased to announce the purchase of 1000 Marina, a six-story 105,000-square-foot office building in San Mateo County, Calif...",
						img: "/images/site/news/.jpg",
						html: dummyCopy
					},
					{				
						date: "January 3",
						source: "theregistry.com",
						author: 'Publisher',
						title: "Meridian Buys 105,000 SF Office Building in San Mateo County for $29MM",
						blurb: "Meridian, a full-service office property developer in California, is pleased to announce the purchase of 1000 Marina, a six-story 105,000-square-foot office building in San Mateo County, Calif...",
						img: "/images/site/news/.jpg",
						html: dummyCopy
					}
				]
			},
			{
				year: 2016,
				articles: [
					{				
						date: "January 3",
						source: "theregistry.com",
						author: 'Publisher',
						title: "Meridian Buys 105,000 SF Office Building in San Mateo County for $29MM",
						blurb: "Meridian, a full-service office property developer in California, is pleased to announce the purchase of 1000 Marina, a six-story 105,000-square-foot office building in San Mateo County, Calif...",
						img: "/images/site/news/.jpg",
						html: dummyCopy
					},
					{				
						date: "January 3",
						source: "theregistry.com",
						author: 'Publisher',
						title: "Meridian Buys 105,000 SF Office Building in San Mateo County for $29MM",
						blurb: "Meridian, a full-service office property developer in California, is pleased to announce the purchase of 1000 Marina, a six-story 105,000-square-foot office building in San Mateo County, Calif...",
						img: "/images/site/news/.jpg",
						html: dummyCopy
					},
					{				
						date: "January 3",
						source: "theregistry.com",
						author: 'Publisher',
						title: "Meridian Buys 105,000 SF Office Building in San Mateo County for $29MM",
						blurb: "Meridian, a full-service office property developer in California, is pleased to announce the purchase of 1000 Marina, a six-story 105,000-square-foot office building in San Mateo County, Calif...",
						img: "/images/site/news/.jpg",
						html: dummyCopy
					},
					{				
						date: "January 3",
						source: "theregistry.com",
						author: 'Publisher',
						title: "Meridian Buys 105,000 SF Office Building in San Mateo County for $29MM",
						blurb: "Meridian, a full-service office property developer in California, is pleased to announce the purchase of 1000 Marina, a six-story 105,000-square-foot office building in San Mateo County, Calif...",
						img: "/images/site/news/.jpg",
						html: dummyCopy
					},
					{				
						date: "January 3",
						source: "theregistry.com",
						author: 'Publisher',
						title: "Meridian Buys 105,000 SF Office Building in San Mateo County for $29MM",
						blurb: "Meridian, a full-service office property developer in California, is pleased to announce the purchase of 1000 Marina, a six-story 105,000-square-foot office building in San Mateo County, Calif...",
						img: "/images/site/news/.jpg",
						html: dummyCopy
					},
					{				
						date: "January 3",
						source: "theregistry.com",
						author: 'Publisher',
						title: "Meridian Buys 105,000 SF Office Building in San Mateo County for $29MM",
						blurb: "Meridian, a full-service office property developer in California, is pleased to announce the purchase of 1000 Marina, a six-story 105,000-square-foot office building in San Mateo County, Calif...",
						img: "/images/site/news/.jpg",
						html: dummyCopy
					}
				]
			},
			{
				year: 2015,
				articles: [
					{				
						date: "January 3",
						source: "theregistry.com",
						author: 'Publisher',
						title: "Meridian Buys 105,000 SF Office Building in San Mateo County for $29MM",
						blurb: "Meridian, a full-service office property developer in California, is pleased to announce the purchase of 1000 Marina, a six-story 105,000-square-foot office building in San Mateo County, Calif...",
						img: "/images/site/news/.jpg",
						html: dummyCopy
					},
					{				
						date: "January 3",
						source: "theregistry.com",
						author: 'Publisher',
						title: "Meridian Buys 105,000 SF Office Building in San Mateo County for $29MM",
						blurb: "Meridian, a full-service office property developer in California, is pleased to announce the purchase of 1000 Marina, a six-story 105,000-square-foot office building in San Mateo County, Calif...",
						img: "/images/site/news/.jpg",
						html: dummyCopy
					}
				]
			}
		];

		$scope.filterArticle = function(year, id){
			var filtered = $filter('filter')($scope.newsSource,{year:year});

			$scope.article = filtered[0].articles[id];
			$scope.article['year'] = year;

		}

	}]);	
}());